<template>
  <section class="layout">
    <div
      class="overflow-x-hidden overflow-y-auto fixed inset-0 z-30 outline-none focus:outline-none justify-center items-center flex"
      v-if="value"
    >
      <!--  max-w-sm, max-w-3xl, max-w-6xl -->
      <div
        class="relative mx-4 my-4 w-full"
        :class="[classStr ? classStr : 'max-w-sm']"
      >
        <!--content-->
        <div
          class="border-0 rounded-xl shadow-lg relative flex flex-col w-full bg-white outline-none focus:outline-none"
        >
          <!--header-->
          <div
            class="flex items-start justify-between px-5 py-2 border-b border-solid border-blueGray-200 rounded-t-xl bg-green-light items-center"
            v-if="!hideModalHeader"
            :class="[headerClass ? headerClass : '']"
          >
            <h3
              class="text-base text-white truncate"
              :class="[headerClass ? headerClass : '']"
            >
              {{ title }}
            </h3>
            <button
              class="ml-auto bg-transparent border-0 text-black opacity-5 float-right text-3xl leading-none outline-none focus:outline-none"
              @click.prevent="close"
            >
              <span
                :class="[
                  whiteCross
                    ? whiteCross
                    : 'bg-transparent pt-0 font-medium text-white opacity-5 h-8 w-8 block outline-none focus:outline-none rounded-md',
                ]"
              >
                ×
              </span>
              <!--text-gray-dark-->
            </button>
          </div>

          <!--body-->
          <div
            class="relative flex-auto text-left"
            :class="[hideModalHeader ? 'p-5' : 'p-5']"
          >
            <slot></slot>
          </div>
        </div>
      </div>
    </div>
    <div v-if="value" class="opacity-75 fixed inset-0 z-20 bg-gray-500"></div>
  </section>
</template>

<script>
export default {
  name: "Modal",
  props: {
    value: {
      required: true,
    },
    title: {
      type: String,
    },
    handleClose: {
      type: Function,
    },
    hideModalHeader: {
      type: Boolean,
      default: false,
    },
    classStr: {
      type: String,
    },
    headerClass: {
      type: String,
    },
    whiteCross: {
      type: String,
    },
  },
  methods: {
    close() {
      if (this.handleClose) {
        this.handleClose(!this.value);
      } else {
        this.$emit("input", !this.value);
      }
    },
  },
};
</script>